export default __webpack_public_path__ + "static/media/carbon_shinpad_sizes.34f53d90.jpg";